module.exports = __webpack_public_path__ + "static/media/37.b8543199.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/37.png
// module id = 998
// module chunks = 0